
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg">
                <i className="ri-delete-bin-fill text-2xl text-teal-600"></i>
              </div>
              <span className="text-2xl font-bold">El Paso Waste Disposal</span>
            </div>
            <p className="text-teal-100 leading-relaxed">
              Professional waste disposal services in El Paso, TX. We provide reliable dumpster rentals and junk removal for residential and commercial projects.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/dumpster-rentals" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Dumpster Rentals
                </Link>
              </li>
              <li>
                <Link to="/roll-off-dumpster-rentals" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Roll Off Dumpster Rentals
                </Link>
              </li>
              <li>
                <Link to="/junk-removal" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Junk Removal
                </Link>
              </li>
              <li>
                <Link to="/eviction-clean-out" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Eviction Clean Out
                </Link>
              </li>
              <li>
                <Link to="/distressed-home-ready" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Distressed Home Preparation
                </Link>
              </li>
              <li>
                <Link to="/hoarding-cleanup" className="hover:text-teal-200 transition-colors cursor-pointer">
                  Hoarding Cleanup
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Contact</h3>
            <div className="space-y-4">
              <a href="tel:9152331754" className="flex items-center gap-3 text-teal-100 hover:text-white transition-colors cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-phone-fill text-xl"></i>
                </div>
                <span>915-233-1754</span>
              </a>
              <div className="flex items-center gap-3 text-teal-100">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-xl"></i>
                </div>
                <span>El Paso, TX</span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Hours</h3>
            <div className="space-y-2 text-teal-100">
              <p>Monday - Friday: 7am - 6pm</p>
              <p>Saturday: 8am - 4pm</p>
              <p>Sunday: Closed</p>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-8 pt-8 text-center text-teal-100">
          <p>&copy; {new Date().getFullYear()} El Paso Waste Disposal. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
